/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, January 10th 2023, 8:50:47 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image, EmphasisText } from "ui-widgets";

export const EmptyFieldsCTA = ({ form }) => {
  return (
    <EmptyStateActionWrapper
      title="No Fields"
      description={
        <>
          <EmphasisText>{form.title}</EmphasisText> does not currently have any fields. To add a field, kindly drag a
          field type from the tool bar on your left.
        </>
      }
      illustrationGraphic={<Image className="image-style-A" src="/img/empty-page.png" alt="Onestop Admin" />}
    />
  );
};
